import { Component, Input, OnInit } from '@angular/core';
import { VendorDocument } from '../../../../../models/VendorDocument';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss']
})
export class InvoiceDetailsComponent implements OnInit {
  @Input() vendordocument: VendorDocument;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/invoices-view/invoice-details/invoice-details.component.ts